<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block _utm-builder"
      @click.self="close"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
      >
        <div class="modal-content rounded-10px">
          <div class="modal-header">
            <div class="modal-title">
              <h5 class="font-weight-bold">
                UTM Parameters Builder
              </h5>
              <p class="font-weight-normal mb-0 text-sm">
                Use UTM tags to get more details about your traffic sources when
                using analytics tools outside of TinyURL.
              </p>
            </div>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <div class="form-group">
            <div class="flex-center-between">
              <label for="preset">Preset</label>
              <div style="width: 186px">
                <FormCheckbox
                  id="create"
                  :value="true"
                  label="Save as New Preset"
                  :is-checked="create"
                  @change="create = !create"
                />
              </div>
            </div>
            <input
              v-if="create"
              v-model="form.name"
              :class="[{ 'is-invalid': form.errors.has('name') }]"
              type="text"
              class="form-control py-4 rounded-10px toned-placeholder"
              placeholder="Enter preset name"
            >
            <v-select
              v-else
              id="preset"
              v-model="preset"
              class="v-select--tinyurl"
              :clearable="false"
              :options="presets"
              :reduce="(preset) => preset.id"
              :selectable="(preset) => preset.id"
              label="name"
            />
            <ValidationMessage :message="form.errors.get('name')" />
          </div>
          <hr> -->
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="source">Source</label>
                <input
                  id="source"
                  v-model="form.utm_source"
                  type="text"
                  class="form-control toned-placeholder bg-transparent rounded-xl py-4"
                  :class="{ 'is-invalid': form.errors.has('utm_source') }"
                  placeholder="e.g. google"
                >
                <ValidationMessage
                  class="_error-source"
                  :message="form.errors.get('utm_source')"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="medium">Medium</label>
                <input
                  id="medium"
                  v-model="form.utm_medium"
                  type="text"
                  class="form-control toned-placeholder bg-transparent rounded-xl py-4"
                  :class="{ 'is-invalid': form.errors.has('utm_medium') }"
                  placeholder="e.g. paid"
                >
                <ValidationMessage
                  class="_error-medium"
                  :message="form.errors.get('utm_medium')"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="campaign">Campaign</label>
                <input
                  id="campaign"
                  v-model="form.utm_campaign"
                  type="text"
                  class="form-control toned-placeholder bg-transparent rounded-xl py-4"
                  :class="{ 'is-invalid': form.errors.has('utm_campaign') }"
                  placeholder="e.g. spring_sale"
                >
                <ValidationMessage
                  class="_error-campaign"
                  :message="form.errors.get('utm_campaign')"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="term">Term</label>
                <input
                  id="term"
                  v-model="form.utm_term"
                  type="text"
                  class="form-control toned-placeholder bg-transparent rounded-xl py-4"
                  :class="{ 'is-invalid': form.errors.has('utm_term') }"
                  placeholder="e.g. url shortener"
                >
                <ValidationMessage
                  class="_error-term"
                  :message="form.errors.get('utm_term')"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="content">Content</label>
                <input
                  id="content"
                  v-model="form.utm_content"
                  type="text"
                  class="form-control toned-placeholder bg-transparent rounded-xl py-4"
                  :class="{ 'is-invalid': form.errors.has('utm_content') }"
                  placeholder="e.g. adlink"
                >
                <ValidationMessage
                  class="_error-content"
                  :message="form.errors.get('utm_content')"
                />
              </div>
            </div>
            <!-- <br>
          <div class="form-row">
            <div class="col-md-6 mb-3 mb-md-0">
              <button
                type="button"
                class="btn btn-block py-2 text-lg rounded-10px btn-outline-blue"
                @click="close"
              >
                Cancel
              </button>
            </div>
            <div class="col-md-6 mb-0">
              <button
                type="button"
                class="btn btn-block py-2 text-lg rounded-10px btn-blue"
                :disabled="form.busy"
                @click="validateUtm"
              >
                {{ startCase(method) }} UTM
              </button>
            </div>
          </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary _cancel-utm"
              @click="close"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-blue text-capitalize _submit-utm"
              :disabled="form.busy"
              @click="validateUtm"
            >
              {{ startCase(method) }} UTM
            </button>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
import vSelect from "vue-select";
import { startCase } from "lodash-es";

import urlStringParamsToJson from "@Helpers/functions/urlStringParamsToJson";
import FormCheckbox from "@Forms/FormCheckbox.vue";
import ValidationMessage from "@Forms/ValidationMessage.vue";

import useNotify from "@Composables/useNotify";

export default {
  name: "UTMBuilder",

  components: { ValidationMessage },

  props: {
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },

    destination: {
      type: String,
      required: true,
    },

    method: {
      type: String,
      required: true,
    },
  },

  setup() {
    const { notifyError } = useNotify();

    return {
      startCase,
      notifyError,
    };
  },

  data: () => ({
    create: false,
    name: null,
    preset: null,
    form: new SparkForm({
      name: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
    }),
    presets: [
      {
        id: null,
        name: "Select Preset",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
      },
    ],
  }),

  computed: {
    rebuildUrl() {
      let params = urlStringParamsToJson(this.destination);
      delete params["utm_source"];
      delete params["utm_medium"];
      delete params["utm_campaign"];
      delete params["utm_term"];
      delete params["utm_content"];
      params = { ...params, ...this.validUtm };
      params = new URLSearchParams(params).toString();

      const url = this.destination.split("?")[0];
      return `${url}${params ? `?${params}` : ``}`;
    },

    validUtm() {
      // prettier-ignore
      return Object.fromEntries(
        Object.entries({
          utm_source: this.form.utm_source ? encodeURIComponent(this.form.utm_source) : null,
          utm_medium: this.form.utm_medium ? encodeURIComponent(this.form.utm_medium) : null,
          utm_campaign: this.form.utm_campaign ? encodeURIComponent(this.form.utm_campaign) : null,
          utm_term: this.form.utm_term ? encodeURIComponent(this.form.utm_term) : null,
          utm_content: this.form.utm_content ? encodeURIComponent(this.form.utm_content) : null,
        }).filter(([_, v]) => v),
      );
    },
  },

  watch: {
    preset(id) {
      const preset = this.presets.find((p) => p.id == id);

      this.form.utm_source = preset.utm_source;
      this.form.utm_medium = preset.utm_medium;
      this.form.utm_campaign = preset.utm_campaign;
      this.form.utm_term = preset.utm_term;
      this.form.utm_content = preset.utm_content;
    },
  },

  created() {
    this.loadUtms();
    this.loadUtm();
  },

  methods: {
    close() {
      this.$emit("close");
    },

    addUtm() {
      if (this.create) {
        const config = { DISABLE_ERROR_INTERCEPTORS: true };
        const url = this.$apiUrl(`preset/create`);
        const payload = this.utm;

        this.form.startProcessing();

        axios
          .post(url, payload, config)
          .then(() => {
            this.callback(this.rebuildUrl);
            this.close();
          })
          .catch((error) => {
            if (error.response?.status === 422) {
              this.form.setErrors(error.response.data.errors);
            } else {
              if (_.has(error, "response.data.message")) {
                this.notifyError({ text: error.response.data.message });
              } else {
                this.notifyError({ text: this.$t("something_went_wrong") });
              }
            }
          })
          .finally(() => {
            this.form.finishProcessing();
          });
      } else {
        this.callback(this.rebuildUrl);
        this.close();
      }
    },

    loadUtms() {
      this.presets.push({
        id: 1,
        name: "Preset A",
        utm_source: "A",
        utm_medium: "Header",
        utm_campaign: "Campaign-A",
        utm_term: "Some keywords",
        utm_content: "Some content",
      });

      this.presets.push({
        id: 2,
        name: "Preset B",
        utm_source: "B",
        utm_medium: "Header",
        utm_campaign: "Campaign-B",
        utm_term: "Some keywords",
        utm_content: "Some content",
      });
    },

    loadUtm() {
      const params = urlStringParamsToJson(decodeURIComponent(this.destination));

      Object.keys(params).forEach((param) => {
        this.form[param] = params[param]
          ? decodeURIComponent(params[param])
          : null;
      });
    },

    validateUtm() {
      const messages = (validation, attr, opts) => {
        // prettier-ignore
        switch (validation) {
          case "required": return `The utm ${attr} field is required.`;
          case "max_length": return `The utm ${attr} must not be greater than ${opts}.`;
        }
      };

      const errors = {
        utm_source: [],
        utm_medium: [],
        utm_campaign: [],
        utm_term: [],
        utm_content: [],
      };

      const MAX_SOURCE_LENGTH = 100;
      const MAX_MEDIUM_LENGTH = 50;
      const MAX_CAMPAIGN_LENGTH = 150;
      const MAX_TERM_LENGTH = 50;
      const MAX_CONTENT_LENGTH = 100;

      // validate utm source
      if (!this.form.utm_source?.length) {
        errors.utm_source.push(messages("required", "source"));
      } else {
        if (this.form.utm_source?.length > MAX_SOURCE_LENGTH) {
          errors.utm_source.push(
            messages("max_length", "source", MAX_SOURCE_LENGTH),
          );
        }
      }

      // validate utm medium
      if (!this.form.utm_medium?.length) {
        errors.utm_medium.push(messages("required", "medium"));
      } else {
        if (this.form.utm_medium?.length > MAX_MEDIUM_LENGTH) {
          errors.utm_medium.push(
            messages("max_length", "medium", MAX_MEDIUM_LENGTH),
          );
        }
      }

      // validate utm campaign
      if (!this.form.utm_campaign?.length) {
        errors.utm_campaign.push(messages("required", "campaign"));
      } else {
        if (this.form.utm_campaign?.length > MAX_CAMPAIGN_LENGTH) {
          errors.utm_campaign.push(
            messages("max_length", "campaign", MAX_CAMPAIGN_LENGTH),
          );
        }
      }

      // validate utm term
      if (
        this.form.utm_term?.length &&
        this.form.utm_term?.length > MAX_TERM_LENGTH
      ) {
        if (this.form.utm_term?.length > MAX_TERM_LENGTH) {
          errors.utm_term.push(messages("max_length", "term", MAX_TERM_LENGTH));
        }
      }

      // validate utm content
      if (
        this.form.utm_content?.length &&
        this.form.utm_content?.length > MAX_CONTENT_LENGTH
      ) {
        if (this.form.utm_content?.length > MAX_CONTENT_LENGTH) {
          errors.utm_content.push(
            messages("max_length", "content", MAX_CONTENT_LENGTH),
          );
        }
      }

      // delete nullish or empty validation key
      Object.keys(errors).forEach((attr) => {
        if (!errors[attr].length) delete errors[attr];
      });

      // set the errors
      this.form.setErrors(errors);

      // add utm if there are no errors
      if (!this.form.errors.hasErrors()) this.addUtm();
    },
  },
};
</script>
